import * as React from 'react';
import { useSelector } from 'react-redux';
import { getSelectedTeamAccountContent } from '../../../../../selectors/uiSelector';
import { getCurrencyByTeamAccountCountry } from '../../../../../utils/currency';
import i18n from '../../../../../i18n';
import { formatMoney } from '@doordash/lib-i18n';
import { GroupOrderEntryStatus } from '../../../../../types/GloblalTypes';
import { getIsWithin24HrsOrAfterDeliveryTime } from '../Calendar/CalendarHelper';
import { TEAM_ACCOUNT_COUNTRY_CODE } from '../../../../../types/portal_data';
import EntryViewCartCreated from './EntryViewCartCreated';
import EntryViewCheckoutAvailable from './EntryViewCheckoutAvailable';
import EntryViewTrackOrder from './EntryViewTrackOrder';
import EntryViewCompletedOrder from './EntryViewCompletedOrder';
import EntryViewCancelledOrder from './EntryViewCancelledOrder';
import { CalendarStrings } from '../Calendar/CalendarStrings';
var contentStrings = CalendarStrings.groupOrderEntry;
var GroupOrderEntry = function (_a) {
    var _b, _c;
    var officeCurrentDateTime = _a.officeCurrentDateTime, entry = _a.entry, onDeleteEntry = _a.onDeleteEntry;
    var teamAccount = useSelector(getSelectedTeamAccountContent);
    var teamAccountCountryCode = (_b = teamAccount === null || teamAccount === void 0 ? void 0 : teamAccount.countryCode) !== null && _b !== void 0 ? _b : TEAM_ACCOUNT_COUNTRY_CODE.US;
    var currency = getCurrencyByTeamAccountCountry(teamAccountCountryCode);
    var userLocale = i18n.getCurrentLocale();
    var officeTodayDateTimeFormatted = officeCurrentDateTime.date + "T" + officeCurrentDateTime.time;
    var orderTargetDeliveryTime = entry.targetDeliveryTime;
    var formattedSpendingLimitAmount = formatMoney({
        currency: currency,
        userLocale: userLocale,
        unitAmount: entry.maxParticipantSubtotalInCents,
        concise: true,
    });
    var spendingLimitDescription = formattedSpendingLimitAmount + " " + contentStrings.spendingLimitPerPerson();
    var isWithin24HrsOrAfterDeliveryTime = getIsWithin24HrsOrAfterDeliveryTime(officeTodayDateTimeFormatted, orderTargetDeliveryTime);
    // show checkout available view when:
    // 1. entry status = cart created successfully
    // 2. with 24hrs after the intended delivery time
    // 3. has a cart id
    var showCheckoutAvailable = entry.status ===
        GroupOrderEntryStatus.RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_CREATED_SUCCESS &&
        isWithin24HrsOrAfterDeliveryTime &&
        Boolean((_c = entry.cart) === null || _c === void 0 ? void 0 : _c.id);
    var isCartCheckedOut = entry.status ===
        GroupOrderEntryStatus.RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_SUBMITTED_SUCCESS;
    var isOrderCompleted = entry.status ===
        GroupOrderEntryStatus.RECURRING_GROUP_ORDER_CALENDAR_STATUS_ORDER_DELIVERY_COMPLETED;
    var isCartCancelled = entry.status ===
        GroupOrderEntryStatus.RECURRING_GROUP_ORDER_CALENDAR_STATUS_ORDER_CANCELLED;
    var showSpendingLimit = entry.status ===
        GroupOrderEntryStatus.RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_CREATED_SUCCESS &&
        Boolean(entry === null || entry === void 0 ? void 0 : entry.maxParticipantSubtotalInCents);
    if (showCheckoutAvailable) {
        return (React.createElement(EntryViewCheckoutAvailable, { entry: entry, showSpendingLimit: showSpendingLimit, spendingLimitDescription: spendingLimitDescription, onDeleteEntry: onDeleteEntry }));
    }
    if (isCartCheckedOut) {
        return React.createElement(EntryViewTrackOrder, { entry: entry });
    }
    if (isOrderCompleted) {
        return React.createElement(EntryViewCompletedOrder, { entry: entry });
    }
    if (isCartCancelled) {
        return React.createElement(EntryViewCancelledOrder, { entry: entry });
    }
    if (!isWithin24HrsOrAfterDeliveryTime) {
        return (React.createElement(EntryViewCartCreated, { entry: entry, showSpendingLimit: showSpendingLimit, spendingLimitDescription: spendingLimitDescription, onDeleteEntry: onDeleteEntry }));
    }
    return null;
};
export default GroupOrderEntry;
